// app/shared/hooks/useLoadingHook.ts
"use client";

import { useEffect } from "react";

import { useLoadingStore } from "../store/loadingStore";

/**
 * Hook to update the global loading state
 *
 * @param isLoading Loading state to track
 */
export const useLoadingHook = (isLoading: boolean) => {
  const { setIsLoading } = useLoadingStore();

  useEffect(() => {
    setIsLoading(isLoading);

    // Clean up by setting loading to false when unmounting
    return () => {
      setIsLoading(false);
    };
  }, [isLoading, setIsLoading]);
};

/**
 * Hook to update a named loading state
 *
 * @param name Unique identifier for this loading state
 * @param isLoading Loading state to track
 */
export const useNamedLoadingHook = (name: string, isLoading: boolean) => {
  const { setNamedLoadingState } = useLoadingStore();

  useEffect(() => {
    setNamedLoadingState(name, isLoading);

    // Clean up by setting loading to false when unmounting
    return () => {
      setNamedLoadingState(name, false);
    };
  }, [name, isLoading, setNamedLoadingState]);
};
